import { changedItems } from '../../util/event-log-items.js';
const CHARACTERISTICS_SPECS = [
    { field: 'weight', unit: 'kg' },
    { field: 'height', unit: 'cm' },
    { field: 'bsa', unit: 'm²', decimals: 2 },
    { field: 'aibw', unit: 'kg', decimals: 2 },
    { field: 'bsa_formula', key: 'bsaFormula', valueKey: 'event.value.bsa_formula.{value}' },
    { field: 'use_aibw', key: 'useAibw', type: 'bool' },
    { field: 'aibw_formula', key: 'aibwFormula', valueKey: 'event.value.aibw_formula.{value}' },
];
const DOSING_BASIS_FIELDS = ['bsa_formula', 'use_aibw', 'aibw_formula'];
const FORMULA_KEYS = ['bsaFormula', 'aibwFormula'];
const PERSONAL_DATA_SPECS = [
    { field: 'name', key: 'fullName' },
    { field: 'birth_date', key: 'birthDate', type: 'date' },
    // sex, gender and title store codes ('male', 'mr') that are themselves the form's translation keys
    { field: 'sex', valueKey: '{value}' },
    { field: 'gender', valueKey: '{value}' },
    { field: 'title', valueKey: '{value}' },
    { field: 'nationality' },
    { field: 'hospital_id', key: 'hospitalPatientId' },
];
const CONTACT_PRIVATE_FIELDS = [
    { field: 'phone', key: 'phone' },
    { field: 'business_phone', key: 'businessPhone' },
    { field: 'email', key: 'email' },
];
/** Changed contact details. The contact name shows old → new; phone numbers and email only show as changed. */
export function contactItems(prev, next) {
    const items = changedItems(prev, next, [{ field: 'contact_name', key: 'name' }]);
    for (const { field, key } of CONTACT_PRIVATE_FIELDS) {
        if (changedItems(prev, next, [{ field, key }]).length > 0) {
            items.push({ field, value: 'changed', valueKey: 'event.value.note.{value}' });
        }
    }
    return items;
}
/** Changed personal data. The national id only shows as changed, never the number. */
export function personalDataItems(prev, next) {
    const items = changedItems(prev, next, PERSONAL_DATA_SPECS);
    const nationalIdChanged = changedItems(prev, next, [{ field: 'national_id', key: 'nationalId' }]).length > 0;
    return nationalIdChanged
        ? [...items, { field: 'national_id', value: 'changed', valueKey: 'event.value.note.{value}' }]
        : items;
}
/**
 * Items and name variant of a characteristics change. `diagnosis` holds the old and new names when the diagnosis changed.
 * `defaultFormulas` are the settings defaults: an empty stored formula meant the default, so saving it is no change.
 */
export function characteristicsLog(prev, next, diagnosis, defaultFormulas) {
    const withDefaults = (row, keys) => {
        const filled = { ...row };
        for (const key of keys)
            filled[key] = row[key] ?? defaultFormulas?.[key] ?? null;
        return filled;
    };
    // a formula left out of the update stays out, so it is not compared
    const nextFormulaKeys = FORMULA_KEYS.filter(key => key in next);
    const items = changedItems(prev && withDefaults(prev, FORMULA_KEYS), withDefaults(next, nextFormulaKeys), CHARACTERISTICS_SPECS);
    if (diagnosis)
        items.push({ field: 'diagnosis', old: diagnosis.old, new: diagnosis.new });
    const changed = new Set(items.map(item => item.field));
    const variant = changed.has('weight') && changed.has('height')
        ? 'weight_height'
        : changed.has('weight')
            ? 'weight'
            : changed.has('height')
                ? 'height'
                : DOSING_BASIS_FIELDS.some(field => changed.has(field))
                    ? 'dosing_basis'
                    : changed.has('diagnosis')
                        ? 'diagnosis'
                        : 'other';
    return { items, variant };
}
//# sourceMappingURL=patient-log-items.js.map